import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {FeedbackFormCheckboxSet} from 'shells/billing/feedback-page/feedback-form-checkbox-set';
import {FeedbackFormWrapper} from 'shells/billing/feedback-page/feedback-form-wrapper';
import {Button} from 'shells/button/button';
import {CheckboxGroup} from 'shells/checkbox/checkbox-group';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

import type {ChurnInfoUpdateInput} from 'nutshell-graphql-types';

import {churnReasonCategories} from './consts';

type Props = {
    onSubmit: (churnInfo: ChurnInfoUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
};

export function ChurnForm({onSubmit, isLoading, error}: Props) {
    const [selectedReasons, setSelectedReasons] = React.useState([]);
    const [additionalComments, setAdditionalComments] = React.useState('');
    const [priceDifference, setPriceDifference] = React.useState(0);

    // store price difference and clear it from URL
    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.has('priceDifference')) {
            setPriceDifference(Number.parseInt(params.get('priceDifference') || '0'));

            params.delete('priceDifference');
            const newUrl = params.toString()
                ? `${window.location.pathname}?${params.toString()}`
                : window.location.pathname;
            window.history.replaceState({}, '', newUrl);
        }
    }, []);

    // @ts-expect-error
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            churnInfo: {
                selectedReasons,
                additionalComments,
                priceDifference,
            },
        });
    };

    const submitButtonDisabled =
        isLoading || (selectedReasons.length === 0 && additionalComments.length === 0);

    return (
        <FeedbackFormWrapper onSubmit={handleSubmit}>
            <Stack spacing={32} alignItems='start'>
                <Body isBold={true} textAlign='center' isFullWidth={true}>
                    What’s prompting you to make this change?
                </Body>
                <CheckboxGroup
                    name='churn-reason'
                    selectedValues={selectedReasons}
                    // @ts-expect-error
                    onChange={setSelectedReasons}
                >
                    <Stack spacing={32}>
                        {churnReasonCategories.map((category) => (
                            <FeedbackFormCheckboxSet
                                key={category.title}
                                title={category.title}
                                options={category.options}
                            />
                        ))}
                    </Stack>
                </CheckboxGroup>
                <Stack spacing={8} alignItems='start' isFullWidth={true}>
                    <Body isBold={true}>Other</Body>
                    <TextField
                        value={additionalComments}
                        onChange={(e) => setAdditionalComments(e)}
                        multiline={true}
                        rows={4}
                        placeholder='Enter comment(s)'
                    />
                </Stack>
                {error && <Body color='error'>{error}</Body>}
                <Button
                    type='submit'
                    variant='primary'
                    size='xlarge'
                    isFullWidth={true}
                    disabled={submitButtonDisabled}
                >
                    {isLoading ? 'Submitting...' : 'Submit survey'}
                </Button>
                <div className='text-align-center full-width'>
                    {/* @ts-expect-error */}
                    <Link as={RoutedLink} to='/setup/billing'>
                        No thanks, take me back to billing
                    </Link>
                </div>
            </Stack>
        </FeedbackFormWrapper>
    );
}
